import { useCallback, useEffect, useState } from "react";
import config from "../../../config/config";
import AddCustomerForm from "./addCustomerForm";
import { CustomerFactory, CustomerEditFactory } from "../../../factory/customerFactory";
import { CustomerApiFactory } from "../../../apiFactory/customerApiFactory";
import { codService } from "../../../requests/codAdminService";
import { refreshCustomerTableData } from "../../../observers/dataObserver";
import ConfirmationModal from "../../ui/ConfirmationModal";
// Styles
const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  maxHeight:"100vh",
  background: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  zIndex: 10,
};

const modalStyle = {
  background: "white",
  borderRadius: "8px",
  width: "550px",
  padding: "20px",
  position: "relative",
  textAlign: "left",
  height:"470px",
  overflow:"hidden",
  overflowY:"auto"
};

const closeButtonStyle = {
  position: "absolute",
  top: "10px",
  right: "10px",
  background: "transparent",
  border: "none",
  fontSize: "18px",
  cursor: "pointer",
  color: "#333",
};

const AddCustomerFormModal = ({ show, onClose, isEdit, customerData }) => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false); // ✅ loader state
  const [subscriptionOptions, setSubscriptionOptions] = useState([]);
const [alertModal, setAlertModal] = useState({ open: false, heading: "", message: "" }); // ✅ state for custom modal
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const fetchSubscriptionPlans = useCallback(async () => {
    try {
      const result = await codService.getSubscriptionPlans();
  
      if (!result.ok) throw new Error("Failed to fetch subscription plans");
  
      const plans = result.data?.plans?.filter(plan => plan?.Status) || [];
      const formattedPlans = plans.map(plan => ({
        value: plan.Plan_Name,
        display_value: plan.Plan_Name,
      }));
  
      setSubscriptionOptions(formattedPlans);
    } catch (err) {
      console.error("❌ Error fetching subscription plans:", err);
    }
  }, []);

  useEffect(() => {
    fetchSubscriptionPlans();
  }, [fetchSubscriptionPlans]);

  useEffect(() => {
    if (isEdit) {
      setFormData(CustomerEditFactory(customerData));
    } else {
      setFormData(CustomerFactory({}));
    }
  }, [isEdit, customerData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    try {
      const payload = CustomerApiFactory(formData);
      const result = await codService.add_Customer(payload);
  
      if (result.ok) {
        console.log("✅ Customer saved successfully:", result.data);
        refreshCustomerTableData.push("refresh");
        onClose();
      } else {
        console.error("❌ Failed to add customer:", result.data);
        // alert(result.data?.error || "Failed to save customer.");
        setAlertModal({
          open: true,
          heading: "Error",
          message: result.data?.error || "Failed to save customer.",
        });
      }
    } catch (error) {
      console.error("❌ Network or server error:", error);
      // alert("Something went wrong. Please try again.", error);
       setAlertModal({
        open: true,
        heading: "Error",
        message: "Something went wrong. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
<>

    <div className="modal" style={overlayStyle}>
      <div className="modal-content" style={modalStyle}>
        <h3 style={{ marginTop: 0, marginBottom: "10px" }}>
          {isEdit ? "Edit Customer" : "Add Customer"}
        </h3>


        <button
          onClick={onClose}
          style={closeButtonStyle}
          aria-label="Close modal"
        >
          ×
        </button>

        {loading ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            ⏳ {isEdit ? "Updating customer..." : "Adding customer..."}
          </div>
        ) : (
          <AddCustomerForm
            formData={formData}
            isEdit={isEdit}
            subscriptionOptions={subscriptionOptions}
            onChange={handleChange}
            onSubmit={handleSubmit}
            onCancel={onClose}
          />
        )}
      </div>
    </div>
     {/* ✅ Custom Alert Modal */}
      <ConfirmationModal
        isOpen={alertModal.open}
        heading={alertModal.heading}
        message={alertModal.message}
        onClose={() => setAlertModal({ open: false, heading: "", message: "" })}
      />
      </>
  );
};

export default AddCustomerFormModal;
